import Image from 'components/image'
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconButton, Textarea, TextInput } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { EditPencil } from 'baby-design/icons'

import { ExternalRegistryFieldsProps } from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/fields/RegItemFields.types'
import { RegItem } from 'src/types/regItem'
import NiceModal from '@ebay/nice-modal-react'
import EditItemDetailsPrivateItemSetting from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/PrivateItem/PrivateItem'
import css from './fields.style.scss'
import { CategoryDropdown } from '../components/CategoryDropdown'
import ProductInfoDrawer from '../../ProductInfoDrawer/ProductInfoDrawer'
import EditRegItemDrawer from '../EditRegItemDrawer'

export function ExternalRegistryFields({
  regItem,
  categories,
  regItemFields,
  updateRegItemFields,
  handleDelete,
}: ExternalRegistryFieldsProps) {
  const openProductInfoDrawer = async () => {
    const response: RegItem | undefined = await NiceModal.show(
      ProductInfoDrawer,
      { regItem }
    )
    if (response) {
      NiceModal.show(EditRegItemDrawer, { regItem: response })
    }
  }

  return (
    <div className={css.fields}>
      <div className={css.fields__item_intro}>
        <Image
          alt={regItemFields.title}
          className={css.fields__item_intro_img}
          src={regItemFields.imgUrl}
        />
        <div className={css.fields__item_intro_info}>
          <div className={css.fields__item_title}>{regItemFields.title}</div>
        </div>
        <IconButton
          className={css.fields__image_edit}
          size="sm"
          variant="fill-inverted"
          onClick={openProductInfoDrawer}
        >
          <EditPencil />
        </IconButton>
      </div>
      <div className={css.fields__item_details}>
        <div className={css.fields__item_input}>
          <TextInput
            inputProps={{
              placeholder: 'https://',
              value: regItemFields.url,
              onChange: (e) => updateRegItemFields({ url: e.target.value }),
            }}
            label="Link to registry"
            size="md"
          />
          <CategoryDropdown
            categories={categories}
            regItemFields={regItemFields}
            updateRegItemFields={updateRegItemFields}
          />
          <Textarea
            label="Notes to friends and family "
            placeholder="Tell Gift Givers what they should know about this registry."
            size="md"
            value={regItemFields.description || undefined}
            onChange={(e) =>
              updateRegItemFields({ description: e.target.value })
            }
          />
          <EditItemDetailsPrivateItemSetting
            categories={categories}
            regItemFields={regItemFields}
            updateRegItemFields={updateRegItemFields}
          />
        </div>
      </div>
      <div className={css.fields__divider} />
      <div className={css.fields__item_delete}>
        {/* eslint-disable-next-line */}
        <a className={css.fields__delete_link} onClick={handleDelete}>
          Delete item
        </a>
      </div>
    </div>
  )
}
